


























































import {Component, Prop, Vue} from 'vue-property-decorator'
import {Action, State} from 'vuex-class'
import {BookingSearchRequest, BookingState, Layer} from '@/store/modules/booking'
import {AppConfigState} from '@/store/modules/configuration'
import {ProfileState} from '@/store/modules/profile'
import {Poi, VehicleSlot} from '@/lib/kepler/interfaces'
import ServiceMesh from '@/lib/serviceMesh'
import sdk from '@/lib/kepler/sdk'
import collect from 'collect.js'
import {EventBus} from '@/main'
import Utils from '@/utils'
import {now} from 'moment'
import {Filter, Filters, MapState} from '@/store/modules/map'
import Btn from '@/components/proxy/Btn.vue'
import Avatar from '@/components/proxy/Avatar.vue'
import MapFiltersButton from '@/components/MapFiltersButton.vue'
import TopBarPopUp from '@/components/TopBarPopUp.vue'
import GradientCard from '@/components/GradientCard.vue'

@Component({
  name: 'MapFilters',
  components: {
    GradientCard,
    TopBarPopUp,
    MapFiltersButton,
    Avatar,
    Btn,
    ToggleableButton: Utils.loadComponent('ToggleableButton'),
    ToolbarTitle: Utils.loadComponent('proxy/ToolbarTitle'),
    Container: Utils.loadComponent('proxy/Container'),
    CustomIcon: Utils.loadComponent('CustomIcon'),
    Toolbar: Utils.loadComponent('proxy/Toolbar'),
    Divider: Utils.loadComponent('proxy/Divider'),
    Layout: Utils.loadComponent('proxy/Layout'),
    Icon: Utils.loadComponent('proxy/Icon'),
    Flex: Utils.loadComponent('proxy/Flex'),
    Button: Utils.loadComponent('Button'),
  },
})
export default class MapFilters extends Vue {
  @State('booking') public bookingState!: BookingState
  @State('configuration') public configState!: AppConfigState
  @State('profile') public profileState!: ProfileState
  @State('map') public mapState!: MapState
  @State((state) => state.map.filters) public filters!: Filters

  @Action('layersFLush') public layersFlush: any
  @Action('setFilters') public setFilter!: (payload: Filters) => void
  @Action('removeFilters') public removeFilters!: (payload: string[]) => void
  @Action('bookingSearch') public bookingSearch: any
  @Action('bookingPublicSearch') public bookingPublicSearch: any
  @Action('getPoi') public getPoi!: any

  @Prop({}) public hasParkingLots!: boolean
  @Prop() public hasActiveReservations!: boolean

  public working: boolean = false
  protected showFilters = false

  // Hide the filter button when panel is opened
  get mapFilterStyle() {
    const filtersOn = {
      display: 'block',
    }
    const filtersOff = {
      display: 'none',
      zIndex: 0,
    }
    return this.showFilters ? filtersOn : filtersOff
  } // keep

  protected get otherFiltersActive(): boolean {
    return this.hasParkingLots || this.reservationActive
  }

  protected get reservationActive() {
    return this.bookingState.activeReservations.length > 0
  }

  // Build the service mesh to allow buttons and to know what to load
  protected get layerKeys() {
    const colors: any = ServiceMesh.colors

    if (!this.bookingState.meshes) {
      return []
    }

    return this.bookingState.meshes.map((mesh) => {
      const k: string = `${mesh.booking_mode}${mesh.vehicle_type}`.toUpperCase()
      const sm = new ServiceMesh()
      const label: string = sm.vehicleType[k]
      return {
        label,
        key: k,
        color: colors[k],
        booking_mode: mesh.booking_mode,
        vehicle_type_id: mesh.vehicle_type_id,
      }
    })
  }

  // Build the layer array (bookingMode + bookingKey + list of vehicles)
  protected get layersArray() {
    const layers = this.bookingState.layers
    const layersArray: Layer[] = []
    for (const i in layers) {
      if (layers.hasOwnProperty(i)) { // that's a standard forin check
        layersArray.push(layers[i])
      }
    }
    return layersArray
  } // basically all this does is to convert the store object to an array

  protected get nothingToFilter() {
    const hasFilter = (filter: string) => {
      return !!(this.filters[filter] && Object.keys(this.filters[filter]).length)
    }

    const f = this.layerKeys.length > 1
    const p = hasFilter('poi')
    let o = hasFilter('other')
    if (!f && !this.hasParkingLots) {
      o = false
      this.$emit('getMapFilters', true, false)
    }
    return !(o || f || p)
  } // keep

  protected mounted() {
    EventBus.$on('recenter', this.setSearchLayers)
    this.initializeFiltersPOI()
    this.initializeFiltersOther()
  } // keep

  protected destroyed() {
    EventBus.$off('recenter', this.setSearchLayers)
  } // keep

  // Build a list of layers and load them in the central storage
  protected setSearchLayers() {
    return this.layersFlush().then(() => {
      const searchLayers: BookingSearchRequest[] = []

      this.layerKeys.forEach((layer: any) => {
        searchLayers.push(new BookingSearchRequest({
          start: null,
          end: null,
          booking_mode: layer.booking_mode,
          latitude: this.profileState.userPosition ? this.profileState.userPosition.lat : this.configState.appConfig.default_latitude,
          longitude: this.profileState.userPosition ? this.profileState.userPosition.lng : this.configState.appConfig.default_longitude,
          vehicle_type_id: layer.vehicle_type_id,
          vehicle_category_id: null, // TODO: figure out what to do with this
        }, layer.key))
      })

      const promises: any[] = []

      searchLayers.forEach((layerQuery: any) => {
        if (sdk.people.isLogged()) {
          promises.push(this.bookingSearch(layerQuery))
        } else {
          promises.push(this.bookingPublicSearch(layerQuery))
        }
      })

      Promise.all(promises).then(() => {
        this.initializeFiltersVehicles()
        this.getLayerMarkers()
        this.working = false
      })
    })
  }

  // Group by marker position
  protected getLayerMarkers() {
    const markers: any = []

    const serviceMesh = new ServiceMesh()

    this.layersArray.forEach((l: Layer) => {
        if (this.filters.vehicles[l.key] || this.filters.vehicles[l.key] === undefined) { // if enabled in filters
          let c = collect(l.vehicles)
          // Group by vehicle position
          c = c.groupBy((i: VehicleSlot) => {
            return i.position.latitude + ',' + i.position.longitude
          })
          // For each group i have to make a marker
          // noinspection JSUnusedAssignment
          c = c.each((i: any, k: any) => {
            markers.push({
              items: i.items,
              key: k,
              icon: serviceMesh.getImageForVehicle(i.items[0], 'OK'),
              distance: i.items[0].distance,
              position: {
                lat: i.items[0].position.latitude,
                lng: i.items[0].position.longitude,
              },
            })
          })
        }
      },
    )

    this.setPoiMarkers()
    this.$emit('getLayerMarkers', collect(markers).sortBy('distance').all())
    this.$emit('getMapFilters', this.filters.other.zones, this.filters.other.parking)
    this.showFilters = false
  }

  // new stuff -------------------------------------------------------------------------------------------------------

  protected toggleFilter(type: string, key: string) {
    const f = this.filters[type]
    // console.log(f, key, f[key])
    f[key] = !f[key]
    // console.log(f, key, f[key])
    this.setFilter({[type]: f})
  }

  // Vehicles

  protected initializeFiltersVehicles() {
    const filters = this.filters.vehicles || []
    const layers = this.bookingState.layers || []

    const keys = {
      filters: collect(Object.keys(filters)),
      mesh: collect(Object.keys(layers)),
    }

    const removed = keys.filters.diff(keys.mesh).all()
    if (removed.length) {
      // console.log('filters removed', removed)
      this.removeFilters(removed)
    }

    const added = keys.mesh.diff(keys.filters).all() // add or initialize on first open
    if (added.length) {
      // console.log('filters added', added)
      this.addFilters(added)
    }
  }

  protected addFilters(source: string[]) {
    const o: Filter = {}
    source.forEach((v) => {
      o[v] = true
    })
    this.setFilter({vehicles: o})
  }

  // POI

  protected initializeFiltersPOI() {
    return this.getPoi().then((r: Poi[]) => {
      r = r || [] // convert response to empty array if undefined (no endpoint, for example)

      const filter: Filter = this.filters.poi || {} // do not override POI filter obj if present, else create it

      for (const k in filter) { // check if a POI was deleted
        if (filter.hasOwnProperty(k)) {
          const missing = !r.find((p) => p.id === k)
          if (missing) {
            delete filter[k] // if POI is not present in response, delete it from the filters
          }
        }
      }

      r.forEach((p) => { // check if a new POI was added
        if (filter[p.id] === undefined) {
          filter[p.id] = p.visibility !== 'hidden' // add POI as active if not hidden
        }
      })

      return this.setFilter({poi: filter})
    })
  }

  protected poiName(id: string) {
    const poi = this.mapState.poi.find((p) => p.id === id)
    if (poi && poi.display_text) {
      return this.$t(poi.display_text)
    }
    return ''
  }

  protected setPoiMarkers() {
    const poi = this.mapState.poi
    const filter = this.filters.poi
    if (poi && filter) {
      this.$emit('setPoiMarkers', poi.filter((p) => filter[p.id]))
    }
  }

  // OTHER FILTERS

  protected initializeFiltersOther() {
    const filter = this.filters.other
    if (filter === undefined) {
      const other: { [k: string]: boolean } = {
        zones: true,
      }
      if (this.hasParkingLots) {
        other.parking = true
      }
      this.setFilter({other})
    }
  }
}
